import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { sendPasswordResetEmail } from '../utils/apiServices';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState('');
  const navigate = useNavigate();

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await sendPasswordResetEmail(email);
      setMessage('Si el correo está registrado, te enviaremos un enlace para restablecer tu contraseña.');
      setErrors('');
    } catch (error) {
      setErrors('Ocurrió un error. Por favor, intenta nuevamente.');
      setMessage('');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#f4f7fc] to-[#e8f0fe] py-[40px] px-5 max-md:py-5 max-md:px-[15px]">
      <div className="w-full max-w-[600px] animate-fade-in">
        <div className="mb-[30px]">
          <button
            className="inline-flex items-center bg-transparent text-icetex border-0 font-semibold cursor-pointer gap-2 py-3 px-5 rounded-[50px] text-base transition-all duration-300 hover:bg-white hover:-translate-x-[5px] hover:shadow-[0_4px_15px_rgba(0,63,129,0.2)] max-md:text-[0.9rem]"
            onClick={() => navigate('/')}
            type="button"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            Volver al inicio
          </button>
        </div>

        <div className="bg-white text-center rounded-[30px] py-[60px] px-[50px] shadow-[0_20px_60px_rgba(0,63,129,0.15)] max-md:py-[40px] max-md:px-[30px] max-md:rounded-[20px]">
          <div className="flex items-center justify-center mx-auto w-[100px] h-[100px] mb-[30px] bg-gradient-to-br from-icetex to-[#0056b3] rounded-full shadow-[0_10px_30px_rgba(0,63,129,0.3)] max-md:w-[80px] max-md:h-[80px]">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-[50px] h-[50px] text-white max-md:w-[40px] max-md:h-[40px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </div>

          <h1 className="text-texto-oscuro font-extrabold text-[2.2rem] mb-[15px] max-md:text-[1.8rem]">Recupera tu Contraseña</h1>
          <p className="text-texto-sec text-[1.05rem] leading-[1.6] mb-[40px] max-md:text-base">
            Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña
          </p>

          <form onSubmit={handleSubmit} className="text-left">
            <div className="mb-[25px]">
              <label htmlFor="email" className="flex items-center text-texto-oscuro font-bold uppercase gap-2 text-[0.95rem] mb-[10px] tracking-[0.5px]">
                <svg xmlns="http://www.w3.org/2000/svg" className="text-icetex w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                Correo Electrónico
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={handleEmailChange}
                required
                className="w-full outline-none py-4 px-5 border-2 border-[#e8f0fe] rounded-[15px] text-base bg-[#f8fafc] transition-all duration-300 focus:border-icetex focus:bg-white focus:shadow-[0_0_0_4px_rgba(0,63,129,0.1)] placeholder:text-[#94a3b8]"
                placeholder="tu@correo.com"
              />
            </div>

            {errors && (
              <div className="flex items-center gap-3 py-4 px-5 bg-[#fee] border-2 border-[#fcc] rounded-[15px] mb-[25px] animate-shake">
                <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 w-5 h-5 text-[#c00]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <p className="m-0 text-[#c00] text-[0.95rem] font-semibold">{errors}</p>
              </div>
            )}

            {message && (
              <div className="flex items-center gap-3 py-4 px-5 border-2 rounded-[15px] mb-[25px]" style={{ backgroundColor: '#e8f5e9', borderColor: '#c8e6c9' }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#4caf50' }}>
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <p className="m-0 text-[0.95rem] font-semibold" style={{ color: '#2e7d32' }}>{message}</p>
              </div>
            )}

            <button type="submit" className="w-full text-white border-0 font-bold uppercase cursor-pointer py-[18px] bg-gradient-to-br from-icetex to-[#0056b3] rounded-[50px] text-[1.05rem] tracking-[0.5px] shadow-[0_6px_20px_rgba(0,63,129,0.3)] mb-[15px] transition-all duration-300 hover:-translate-y-[0.5px] hover:shadow-[0_8px_25px_rgba(0,63,129,0.4)] active:translate-y-0">
              Enviar correo de recuperación
            </button>

            <Link to="/login" className="w-full bg-transparent text-icetex font-semibold cursor-pointer text-center py-4 border-2 border-icetex rounded-[50px] text-[0.95rem] mb-5 transition-all duration-300 hover:bg-icetex hover:text-white hover:-translate-y-[0.5px] no-underline block" style={{ textDecoration: 'none' }}>
              Volver a Iniciar Sesión
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
